const notes = (state = "", action) => {
    switch(action.type) {
        case 'notes':
            return action.payload;
        default:
            return state;
    }
}

export default notes;